(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodSvg', sodSvg);

    function sodSvg() {
        return {
            scope: {
                type: '@'
            },
            controller: sodSvgCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function sodSvgCtrl($scope, $compile, $templateCache, $element) {
        var vm = this;
        var cloneElement = null;

        this.$onInit = function() {
            var templateUrl = 'common/components/svg/' + vm.type;
            var html = '<div class="' + vm.type + '">' + $templateCache.get(templateUrl) + '</div>';
            $element.html(html);
            cloneElement = $compile($element.contents())($scope);
            $scope.$on('$destroy', scopeDestroy);
        }

        function scopeDestroy() {
            cloneElement.off();
        }
    }
})();